package com.merkost.handpass.api.dto.admin

import com.merkost.handpass.api.enums.ContentFlag
import com.merkost.handpass.api.enums.ImageStatus
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminImageListItem(
    val id: String,
    @SerialName("storage_url") val storageUrl: String,
    val status: ImageStatus,
    val bucket: String,
    @SerialName("uploaded_by") val uploadedBy: String,
    @SerialName("uploader_name") val uploaderName: String? = null,
    @SerialName("listing_id") val listingId: String? = null,
    @SerialName("listing_title") val listingTitle: String? = null,
    val flags: List<ContentFlag> = emptyList(),
    val confidence: Float? = null,
    @SerialName("created_at") val createdAt: String,
    @SerialName("moderated_at") val moderatedAt: String? = null,
)
